import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import FirmaRecibo from './FirmaRecibo';

function MisRecibos() {
  const [recibos, setRecibos] = useState([]);
  const [userId, setUserId] = useState(null);
  const [reciboAFirmar, setReciboAFirmar] = useState(null);

  useEffect(() => { init(); }, []);

  async function init() {
    const { data: { user } } = await supabase.auth.getUser();
    setUserId(user.id);
    const { data } = await supabase
      .from('recibos')
      .select('*')
      .eq('empleado_id', user.id)
      .order('created_at', { ascending: false });
    setRecibos(data || []);
  }

 async function recargar() {
    const { data: { user } } = await supabase.auth.getUser();
    const { data } = await supabase
      .from('recibos')
      .select('*')
      .eq('empleado_id', user.id)
      .order('created_at', { ascending: false });
    setRecibos(data || []);
  }

  return (
    <div className="seccion-container">
      <h2 className="seccion-titulo-pag">Mis recibos de sueldo</h2>

      <div className="lista-recibos">
        {recibos.length === 0 && (
          <p className="dashboard-vacio">No tenes recibos cargados todavia.</p>
        )}
        {recibos.map(r => (
          <div key={r.id} className="recibo-item">
            <div className="recibo-info">
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div className="recibo-periodo">{r.periodo}</div>
                {r.firmado
                  ? <span style={{ background: '#22c55e', color: 'white', fontSize: '0.72rem', padding: '2px 8px', borderRadius: 20, fontWeight: 700 }}>Firmado</span>
                  : <span style={{ background: '#f59e0b', color: 'white', fontSize: '0.72rem', padding: '2px 8px', borderRadius: 20, fontWeight: 700 }}>Sin firmar</span>
                }
              </div>
              <div className="recibo-fecha">{new Date(r.created_at).toLocaleDateString('es-AR')}</div>
              {r.firmado && r.fecha_firma && (
                <div style={{ fontSize: '0.78rem', color: '#22c55e' }}>
                  Firmado el {new Date(r.fecha_firma).toLocaleDateString('es-AR')}
                </div>
              )}
            </div>
            <div className="recibo-acciones">
              <a href={r.url} target="_blank" rel="noreferrer" className="btn-ver-recibo">Ver</a>
              {!r.firmado && (
                <button
                  onClick={() => setReciboAFirmar(r)}
                  style={{ background: '#7c6ff7', color: 'white', border: 'none', padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: '0.85rem', fontWeight: 600 }}
                >
                  Firmar
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      {reciboAFirmar && (
        <FirmaRecibo
          recibo={reciboAFirmar}
          onCerrar={() => setReciboAFirmar(null)}
          onFirmado={() => { setReciboAFirmar(null); recargar(); }}
        />
      )}
    </div>
  );
}

export default MisRecibos;